import { DynamicCol } from "./dynamic-col.model";

export class DynamicColItem<T> extends DynamicCol<T> {

    data?: T;
    property!: keyof T;
    formGroupIndex?: number = -1;

    constructor(source: Partial<DynamicColItem<T>>) {
        super(source);
        this.type = "item";
        Object.assign(this, source);
    }
}